<template>
  <div class="video-wrapper">
    <video
      ref="video"
      :controls="isMobile"
      autoplay
      muted
      webkit-playsinline
      playsinline
      class="video-wrapper__video"
    >
    </video>
  </div>
</template>

<script>
import { WebRTCPlayer } from '@eyevinn/webrtc-player';
export default {
  name: "StreamingNewWebRTCPlayer",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
      errorMessage: "",
      token: localStorage.getItem("credentials"),
      player: null,
    };
  },
  methods: {
    prepareVideoPlayer() {
      this.player = new WebRTCPlayer({
        video: this.$refs.video,
        type: 'whep',
        statsTypeFilter: '^candidate-*|^inbound-rtp',
      });
      this.player.on('no-media', () => {
        console.log('media timeout occured');
      });
      this.player.on('media-recovered', () => {
        console.log('media recovered');
      });

      this.player.on('stats:inbound-rtp', (report) => {
        if (report.kind === 'video') {
          console.log(report);
        }
      });
      this.player.load(new URL(`${this.url}?auth_token=${this.token}`));
    },
    destroyPlayer() {
      this.player.destroy();
    },
  },
  mounted() {
    this.prepareVideoPlayer();
  },
  updated() {
    this.prepareVideoPlayer();
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
}
</script>

<style scoped lang="scss">
.video-wrapper {
  position: relative;
  width: 100%;
  &__video {
    width: 100%;
    aspect-ratio: 16 / 9;
    background-color: #eeeeee;
    border: none;
  }

  .error,
  .loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
  .error {
    color: red;
  }
}
</style>
